/*
 * STORMWARD · Startseite als Forschungs-Bulletin (08.10.2026)
 * Zaehler beim Erscheinen, Erscheinen-Animation, Wirkungsdiagramm mit
 * Netzausfall-Simulation, Haushaltsrechner. Alles ohne Abhaengigkeiten.
 * prefers-reduced-motion: Zahlen stehen sofort, nichts animiert.
 */
(() => {
  if (window.__swLab) return;
  window.__swLab = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Zaehler: <span data-sw-count="80" data-decimals="0">0</span> */
  const fmt = (v, d) => v.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  const count = (el) => {
    const to = Number(el.dataset.swCount);
    const d = Number(el.dataset.decimals || 0);
    if (reduce || !Number.isFinite(to)) { el.textContent = fmt(to, d); return; }
    const t0 = performance.now();
    const dur = 1400;
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(to * e, d);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const observe = () => {
    const els = document.querySelectorAll('[data-sw-count]:not(.is-counted), .sw-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach((el) => { if (el.dataset.swCount) count(el); el.classList.add('is-in', 'is-counted'); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        if (el.dataset.swCount) { count(el); el.classList.add('is-counted'); }
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: 0.25 });
    els.forEach((el) => io.observe(el));
  };

  /* Wirkungsdiagramm: Knopf schaltet Netzausfall an/aus */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sw-mech-toggle]');
    if (!btn) return;
    const box = btn.closest('.sw-mech');
    if (!box) return;
    const failed = box.classList.toggle('is-failed');
    btn.setAttribute('aria-pressed', failed ? 'true' : 'false');
    btn.querySelector('span').textContent = failed ? btn.dataset.labelOn : btn.dataset.labelOff;
    const out = box.querySelector('[data-sw-mech-readout]');
    if (out) out.textContent = failed ? out.dataset.failed : out.dataset.normal;
  });

  /* Haushaltsrechner */
  const calc = (root) => {
    const st = { people: Number(root.dataset.people || 4), days: Number(root.dataset.days || 3) };
    const tiers = (root.dataset.tiers || '').split(',').map((t) => {
      const [total, paid, name] = t.split(':');
      return { total: Number(total), paid: Number(paid), name };
    }).filter((t) => t.total);
    const unit = Number(root.dataset.unit || 0);
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });
    const $ = (s) => root.querySelector(s);
    const render = () => {
      const gal = st.people * st.days;
      $('[data-o="people"]').textContent = st.people;
      $('[data-o="gal"]').textContent = fmt(gal, 0);
      $('[data-o="lb"]').textContent = fmt(Math.round(gal * 8.34), 0);
      $('[data-o="cases"]').textContent = fmt(Math.ceil(gal / 3.17), 0);
      root.querySelectorAll('[data-days]').forEach((b) => b.setAttribute('aria-pressed', Number(b.dataset.days) === st.days ? 'true' : 'false'));
      const need = st.people + 1;
      const t = tiers.find((x) => x.total >= need) || tiers[tiers.length - 1];
      if (t) {
        $('[data-o="tier"]').textContent = t.name;
        const spare = t.total - need;
        const extra = spare > 0 ? ` and ${spare} spare` : (t.total < need ? `, add more in the cart` : '');
        $('[data-o="tiersub"]').textContent = `${t.total} filters: one per person, one for the car${extra} · ${money.format((unit * t.paid) / 100)}`;
        const a = $('[data-o="link"]');
        a.href = `${a.dataset.base}?qty=${t.total}`;
      }
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b || !root.contains(b)) return;
      if (b.dataset.step) st.people = Math.min(10, Math.max(1, st.people + Number(b.dataset.step)));
      if (b.dataset.days) st.days = Number(b.dataset.days);
      render();
    });
    render();
  };

  const init = () => {
    observe();
    document.querySelectorAll('.sw-calc[data-tiers]:not(.is-ready)').forEach((r) => { r.classList.add('is-ready'); calc(r); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
